/**
  基础路由配置
*/

// import Billboard from '@/pages/Billboard';
// import BillboardInbound from '@/pages/BillboardInbound';
// import BillboardInboundStaff from '@/pages/BillboardInboundStaff';
// import BillboardInboundReceive from '@/pages/BillboardInboundReceive';
// import BillboardInboundUnload from '@/pages/BillboardInboundUnload';
// import BillboardInboundUpload from '@/pages/BillboardInboundUpload';
// import BillboardOutbound from '@/pages/BillboardOutbound';
// import BillboardOutboundStaff from '@/pages/BillboardOutboundStaff';
// import BillboardOutboundPicking from '@/pages/BillboardOutboundPicking';
// import BillboardOutboundPackaging from '@/pages/BillboardOutboundPackaging';
import React from 'react';

export default [
  {
    path: '/billboard/index',
    // component: Billboard,
    component: React.lazy(() => import(/* webpackChunkName: 'Billboard' */ '@/pages/Billboard')),
  },
  {
    path: '/billboard/outbound',
    // component: BillboardOutbound,
    component: React.lazy(() => import(/* webpackChunkName: 'BillboardOutbound' */ '@/pages/BillboardOutbound')),
  },
  {
    path: '/billboard/outbound/staff',
    // component: BillboardOutboundStaff,
    component: React.lazy(
      () => import(/* webpackChunkName: 'BillboardOutboundStaff' */ '@/pages/BillboardOutboundStaff'),
    ),
  },
  {
    path: '/billboard/outbound/picking',
    // component: BillboardOutboundPicking,
    component: React.lazy(
      () => import(/* webpackChunkName: 'BillboardOutboundPicking' */ '@/pages/BillboardOutboundPicking'),
    ),
  },
  {
    path: '/billboard/outbound/packaging',
    // component: BillboardOutboundPackaging,
    component: React.lazy(
      () => import(/* webpackChunkName: 'BillboardOutboundPackaging' */ '@/pages/BillboardOutboundPackaging'),
    ),
  },
  {
    path: '/billboard/inbound',
    // component: BillboardInbound,
    component: React.lazy(() => import(/* webpackChunkName: 'BillboardInbound' */ '@/pages/BillboardInbound')),
  },
  {
    path: '/billboard/inbound/staff',
    // component: BillboardInboundStaff,
    component: React.lazy(
      () => import(/* webpackChunkName: 'BillboardInboundStaff' */ '@/pages/BillboardInboundStaff'),
    ),
  },
  {
    path: '/billboard/inbound/receive',
    // component: BillboardInboundReceive,
    component: React.lazy(
      () => import(/* webpackChunkName: 'BillboardInboundReceive' */ '@/pages/BillboardInboundReceive'),
    ),
  },
  {
    path: '/billboard/inbound/unload',
    // component: BillboardInboundUnload,
    component: React.lazy(
      () => import(/* webpackChunkName: 'BillboardInboundUnload' */ '@/pages/BillboardInboundUnload'),
    ),
  },
  {
    path: '/billboard/inbound/upload',
    // component: BillboardInboundUpload,
    component: React.lazy(
      () => import(/* webpackChunkName: 'BillboardInboundUpload' */ '@/pages/BillboardInboundUpload'),
    ),
  },
];
